module.exports = __webpack_public_path__ + "img/caecd985030de2ae6301b4ebbe5bde28.jpg";